var DropSelect = require('sma.admin/components/dropdowns/dropselect')

var groupTempl = require('sma.admin/components/dropdowns/partials/group.mustache')

/* pass in items as a list of objects like this:
 * {
 *     name: 'foo',
 *     text: 'foobar',
 *     items: [{
 *         name: 'subfoo',
 *         text: 'subfoobar',
 *         checked: true
 *     }]
 * }
 */
class DropSelectDrilldown extends DropSelect {
	get events () {
		var events = super.events;
		
		events['click .sma-js-dropselect-group'] = 'changeGroupEvent';

		return events;
	}

	initialize (options) {
		this.selectedGroupIndex = 0;
		this.drilldown = true;

		if (options.changeGroupCallback) {
			this.changeGroupCallback = options.changeGroupCallback;
		}

		if (options.itemSelectDone) {
			this.itemSelectDone = options.itemSelectDone;
		}

		super.initialize(options);
	}

	renderContents () {
		this.renderGroups();
		this.renderItems();
	}

	renderGroups () {
		this.$groups = this.$el.find('.sma-dropselect-sections');
		this.$groups.empty();
		this.groups.forEach(group => {
			this.$groups.append(groupTempl(group));
		});
		this.activateSelectedGroup();
	}

	changeGroupEvent (e) {
		var groupName = $(e.target).prop('name');
		this.updateChangedItems();
		this.changeGroup(groupName);

		return false;
	}

	changeGroup (groupName) {
		this.deactivateCurrentGroup();
		this.selectedGroupIndex  = _.findIndex(this.changedItems, item => item.name === groupName);
		this.activateSelectedGroup(this.selectedGroupIndex);
		this.changeGroupCallback(this.selectedGroupIndex);
	}

	changeGroupCallback(selectedGroupIndex) {
		return;
	}

	deactivateCurrentGroup () {
		var group = this.changedItems[this.selectedGroupIndex];

		this.$groups.find(`[name="${group.name}"]`).replaceWith(groupTempl({
			text: group.text,
			name: group.name,
		}));

	}

	activateSelectedGroup () {

		var group = this.changedItems[this.selectedGroupIndex];
		this.$groups.find(`[name="${group.name}"]`).replaceWith(groupTempl({
			text: group.text,
			name: group.name,
			itemCount: group.items.length,
			active: true,
			noCount: this.noCount || false,
		}));

		this.renderItems();

	}

	get groups () {
		return this.changedItems;
	}

	visibleItems () {
		return this.changedItems[this.selectedGroupIndex].items;
	}

	updateChangedItems () {
		this.changedItems[this.selectedGroupIndex].items = this.displayedItems;
	}
}

module.exports = DropSelectDrilldown;
